import { render, staticRenderFns } from "./MultiMeasurementSelector.vue?vue&type=template&id=70a9f3a4&scoped=true&lang=pug"
import script from "./MultiMeasurementSelector.vue?vue&type=script&lang=js"
export * from "./MultiMeasurementSelector.vue?vue&type=script&lang=js"
import style0 from "./MultiMeasurementSelector.vue?vue&type=style&index=0&id=70a9f3a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9f3a4",
  null
  
)

export default component.exports